import { defineComponent, h } from 'vue';
import { QCard, QCardSection, QIcon, QBadge, QBtn, QTree, QMenu, QList, QItem, QItemSection, QItemLabel, QSeparator } from 'quasar';
import utils from '../../Shared/utils.jsx';
import { normalizeIconName } from '../../Shared/buttonAppearance.js';
import BaseComponent from './BaseComponentMixin.jsx';
import careHelpfulFunctions from '../careHelpfulFunctions.jsx';
import { appSettings } from '../../Shared/appSettings.js';

import EventBus from '../event-bus.js';

import TranslationContainer from './TranslationContainer.jsx';

function resolveMenuIcon(raw) {
    if (raw == null || raw === '')
        return null;

    const iconVal = typeof raw === 'object' && raw.Icon != null ? raw.Icon : raw;
    return normalizeIconName(iconVal) || null;
}

export default defineComponent({
    name: 'dynamic-menu-list',
    mixins: [BaseComponent],
    components: {
        QCard, QCardSection, QIcon, QBadge, QBtn, QTree, QMenu, QList, QItem, QItemSection, QItemLabel, QSeparator,
        TranslationContainer,
    },
    data: function () {
        return {
            menutitle: null,
            sourceraw: null,
            sourceurl: null,
            model: null,
            tab_state: {
                index: 0
            },
            selected_item: null,
            selected_data: null,
            selected_values: [],

            expanded_keys: [],

            cached_content: null,

            contextMenuItem: null,
            showMenu: false,
            x: 0,
            y: 0,

            titlebgcolorexpn: null,
        }
    },
    async created() {
        if (this.controlData.SourceType === 'Raw' && this.controlData.SourceRaw) {
            this.sourceraw = utils.compileObject(this, this.controlData.SourceRaw);
        }
        else if (this.controlData.SourceType === 'Url' && this.controlData.SourceUrl) {
            this.sourceurl = utils.compile(this, this.controlData.SourceUrl);
        }

        EventBus.$on('Action-SelectMenuItem-Menu', this.performSelectMenuItem);
    },
    //Mounted Replaced with preRenderComplete
    unmounted() {
        EventBus.$off('Action-SelectMenuItem-Menu', this.performSelectMenuItem);
    },
    computed: {
        MenuTitle() {
            const title = this.controlData.MenuTitle;
            if (title)
                return (
                    <TranslationContainer context={this} value={title}></TranslationContainer>
                );
            return null;
        },
        SelectedId: function () {
            return this.selected_item;
        },
        Menus: function () {
            return utils.document_cache.menus;
        },
        DocumentCache: function () {
            // This used to be in the SourceRaw:
            // "{# utils.document_cache.getMenuTree(SourceData().MenuItemData.ChildMenuName) #}"

            return utils.document_cache;
        },
        MenuData: function () {
            return this.model;
        },
        MenuContent: function () {
            return this.cached_content;
        },
        AllItems: function () {
            // Returns a flattened array of all menu items
            const flat = [];
            this.getFlatModel(this.model, flat);
            return flat;
        },

        labelForceRefresh: function () {
            return this.Translate('Force Refresh');
        },
        labelMenuInfo: function () {
            return this.Translate('Menu Info');
        },
        menuTitleBackgroundColor: function () {
            if (!this.titlebgcolorexpn && this.controlData.MenuTitleBackgroundColor)
                this.titlebgcolorexpn = utils.compile(this, this.controlData.MenuTitleBackgroundColor);

            return this.titlebgcolorexpn ? utils.evaluate(this.titlebgcolorexpn, this) : undefined;
        },
        menuItemsFiltered: function () {
            if (this.model) {
                let model = [];
                this.filterChildren(this.model, model);
                return model;
            }
            else
                return [];
        },
    },
    methods: {
        isParentNode(node) {
            return !!(node?.children && node.children.length > 0);
        },
        /** Parent: expand only. Leaf: content selection. */
        handleNodeActivate(node) {
            if (this.isParentNode(node)) {
                this.toggleExpanded(node.id);
                return;
            }
            this.onInput([node.id]);
        },
        async preRenderComplete() {
            await this.Refresh();
            this.finishRenderHandler(this);
        },
        async performSelectMenuItem(action) {
            // Note: this action is only triggered by the NavigationDrawer after it receives the base SelectMenuItem. This
            // is to allow the menu to materialize before trying to select it.
            utils.log(`DynamicMenuList SelectMenuItem-Menu ${action.ActionData.MenuItemName}`);

            if (action.ActionData.Debug && action.ActionData.Debug.BreakPoint) debugger;

            try {
                const name = utils.evaluate(action.menuname, action.context);

                utils.executeAndCompileAllActions(this.controlData.SelectMenuActions, { Data: name }, this);

                try {
                    await utils.success(action);
                } catch (e) { }
            }
            catch (e) {
                try {
                    await utils.failure(action, { Data: e });
                } catch (e) { }
            }
            finally {
                try {
                    await utils.complete(action);
                }
                catch (e) { }

                // Complete the promise for the executeAction method
                action.FinishFunc(true);
            }
        },
        filterChildren: function (sourcemodel, finalmodel) {
            for (let i = 0; i < sourcemodel.length; i++) {
                const item = sourcemodel[i];
                const dest = { ...item };
                if (dest.item_data && dest.item_data.MenuItemData.ControlData && dest.item_data.MenuItemData.ControlData.DisplayExpression && !dest.$displayexpn)
                    dest.$displayexpn = utils.compileExpression(this, dest.item_data.MenuItemData.ControlData.DisplayExpression);

                if (dest.item_data && !utils.document_cache.hasAccess('dynamic menu list item', dest.item_data.AccessPermission))
                    continue;

                if (dest.item_data && dest.item_data.MenuItemData.ControlData && dest.item_data.MenuItemData.ControlData.DisplayExpression && dest.$displayexpn) {
                    if (!utils.evaluate(dest.$displayexpn, this))
                        continue;
                }

                if (item.children) {
                    const children = [];
                    this.filterChildren(item.children, children);
                    dest.children = children;

                    // if there are no children do not add the parent
                    if (children.length > 0) {
                        // Parents expand/collapse only — content selection is leaf-only
                        dest.selectable = false;
                        finalmodel.push(dest);
                    }
                }
                else {
                    dest.selectable = true;
                    finalmodel.push(dest);
                }
            }
        },
        getFlatModel: function (model, flat) {
            for (let i = 0; i < model.length; i++) {
                const a = model[i];
                flat.push(a);
                if (a.children)
                    this.getFlatModel(a.children, flat);
            }
        },
        getChildren: function (data, parent, outargs) {
            let path = parent.MenuItemData.Title;
            if (parent.MenuPath)
                path = parent.MenuPath + '::' + path;

            const list = data.filter(m => m.MenuPath == path).sort((a, b) => parseInt(a.Index) - parseInt(b.Index));

            const result = [];
            for (let i = 0; i < list.length; i++) {
                const item = list[i];
                const child = {
                    id: `${outargs.index++}`,
                    name: item.MenuItemData.Title,
                    icon: item.MenuItemData.Icon,
                    item_data: item,
                }
                outargs.content.push(child);
                const children = utils.document_cache.getChildren(data, item, outargs);
                if (children && children.length > 0)
                    child.children = children;

                result.push(child);
            }

            return result;
        },
        getMenuTree: function (data) {
            const result = [];
            const content = [];
            const outargs = { index: 0, content: content };

            let root = data.filter(m => !m.MenuPath).sort((a, b) => parseInt(a.Index) - parseInt(b.Index));
            for (let i = 0; i < root.length; i++) {
                const node = root[i];
                const child = {
                    id: `${outargs.index++}`,
                    name: node.MenuItemData.Title,
                    icon: node.MenuItemData.Icon,
                    item_data: node,
                };
                outargs.content.push(child);
                const children = this.getChildren(data, node, outargs);
                if (children && children.length > 0)
                    child.children = children;

                result.push(child);
            }
            this.cached_result = result;
            this.cached_content = content;
            return result;
        },
        async Refresh() {
            let model;
            if (this.sourceraw)
                try {
                    model = utils.evaluateObject(this.sourceraw, this);
                }
                catch (e) {
                    utils.warn('DynamicTab failed to evaluate SourceRaw ' + this.controlData.SourceRaw + ': ' + e);
                }
            else if (this.sourceurl)
                try {
                    model = await utils.api.get(utils.evaluate(this.sourceurl, this));
                }
                catch (e) {
                    utils.warn('DynamicTab failed to evaluate SourceUrl ' + this.controlData.SourceUrl + ': ' + e);
                }

            if (this.controlData.SourceAsMenuItems) {
                if (!model)
                    debugger;

                // Convert the source model into a tree (it is being provided as an array of MenuItems)
                this.model = this.getMenuTree(model);

                const defaultIndex = this.model.findIndex(a => a.item_data.MenuItemData.IsDefault);
                if (defaultIndex >= 0) {
                    this.onInput([this.model[defaultIndex].id]);
                }
            }
            else
                this.model = model;
        },
        findItem(parent, id) {
            if (parent && typeof parent === 'object' && Array.isArray(parent))
                for (let i = 0; i < parent.length; i++) {
                    const child = parent[i];
                    if (child.id == id)
                        return child;

                    if (child.children) {
                        const item = this.findItem(child.children, id);
                        if (item)
                            return item;
                    }
                }
            return null;
        },
        async onInput(selectedvalues) {
            if (!selectedvalues || selectedvalues.length === 0)
                return;

            // Defense: parents never own content selection (QTree onUpdate:selected, defaults, etc.)
            const nextId = selectedvalues[0];
            const nextItem = this.findItem(this.model, nextId);
            if (this.isParentNode(nextItem))
                return;

            // selectedvalues is an array of Ids that match the id property within the selected menu item
            if (this.selected_data && this.selected_item && this.selected_data.item_data?.MenuItemData?.OnDeactivateActions?.length > 0) {
                console.log(`DynamicTabContent - MenuList onInput: ${JSON.stringify(selectedvalues)}`);

                await utils.executeAndCompileAllActions(this.selected_data.item_data.MenuItemData.OnDeactivateActions, { Data: this.selected_item, SelectedItem: this.selected_data }, this);
                this.selected_values = [];
                this.selected_item = null;
                this.selected_data = null;
            }

            console.log(`DynamicTabContent + MenuList onInput: ${JSON.stringify(selectedvalues)}`);

            // Keep visual chrome and content id in sync (leaf-only)
            this.selected_values = selectedvalues;
            this.selected_item = nextId;
            this.selected_data = nextItem;

            if (this.selected_data?.item_data?.MenuItemData?.OnActivateActions) {
                await utils.executeAndCompileAllActions(this.selected_data.item_data.MenuItemData.OnActivateActions, { Data: this.selected_item, SelectedItem: this.selected_data }, this);
            }

            await utils.executeAndCompileAllActions(this.controlData.Actions, { Data: this.selected_item, SelectedItem: this.selected_data }, this);
        },
        async lookupBadge(url, tooltip, item) {
            if (url) {
                const promise = utils.api.get(url);
                const tooltipexpr = utils.compile(this, tooltip);
                const res = await promise;
                this.Input = {
                    Count: (typeof res === 'object' && res && 'Result' in res) ? res.Result : res,
                };
                if (this.Input.Count > 0) {
                    const value = utils.evaluate(tooltipexpr, this);
                    item.badgecontent = this.Input.Count < 100 ? `${this.Input.Count}` : "99+";
                    item.tooltip = value;
                    item.showbadge = true;
                }
                else {
                    item.showbadge = false;
                }
            }
        },
        findBadges(item) {
            const badgelist = [];

            if (item.item_data.MenuItemData) {
                const badgeinfo = item.item_data.MenuItemData.Badge;
                if (badgeinfo && !item.badgecontent && (badgeinfo.LookupType == 'URL' || (!badgeinfo.LookupType && badgeinfo.CountURL))) {
                    badgelist.push(badgeinfo);
                }
            }
            if (item.children) {
                const ci = item.children.filter(a => a.item_data && a.item_data.MenuItemData && a.item_data.MenuItemData.Badge && (a.item_data.MenuItemData.Badge.LookupType || a.item_data.MenuItemData.Badge.CountURL));
                for (let i = 0; i < ci.length; i++) {
                    const c = ci[i];
                    const b = this.findBadges(c);
                    for (let j = 0; j < b.length; j++)
                        badgelist.push(b[j]);
                }
            }
            return badgelist;
        },
        SelectItem(id) {
            // Return the onInput promise so callers (e.g. selectMenuByPath / careAgent) can await OnActivate.
            return this.onInput([id]);
        },
        toggleExpanded(nodeId) {
            const idx = this.expanded_keys.indexOf(nodeId);
            if (idx >= 0)
                this.expanded_keys = this.expanded_keys.filter((_, i) => i !== idx);
            else
                this.expanded_keys = [...this.expanded_keys, nodeId];
        },
        menuItemRefresh(e, item) {
            e.cancelBubble = true;
            e.stopPropagation();

            utils.api.clearCache();

            if (item.MenuItemData && item.MenuItemData.ControlData)
                item.MenuItemData.ControlData.$objectId = utils.generateUUID();
        },
        showContextMenu(e, item) {
            this.contextMenuItem = item;
            e.preventDefault()
            this.showMenu = false
            this.x = e.clientX
            this.y = e.clientY
            this.$nextTick(() => {
                this.showMenu = true
            })
        },
        getMenuNameAndPath(menu) {
            let name = menu.MenuName + ' / ';
            if (menu.MenuPath)
                name += menu.MenuPath + ' / ';

            name += menu.MenuItemData.Title;

            return name;
        },
        openForLocalEdit(e, item) {
            e.preventDefault()
            utils.openForLocalEdit({ Type: 'MenuItem', Id: item._id, Name: this.getMenuNameAndPath(item) });
        },
        openForExternalEdit(e, item, controlOwnerId, shared) {
            e.preventDefault();
            utils.OpenEditorForExternalEdit({ Type: 'MenuItem', Id: item._id, Name: this.getMenuNameAndPath(item),  OwnerId: controlOwnerId }, shared);
        },
    },
    props: {
    },
    render() {
        if (!this.todisplay || !this.controlData)
            return null;

        const style = {
            minWidth: "25px",
            background: '#fff',
            ...this.sizeStyle,
            ...utils.resolveStyleHints(this.styleHints, this),
        };

        let title;
        if (this.MenuTitle)
            title = (
                <QCardSection class="text-h6 q-pa-md" style={{ backgroundColor: this.menuTitleBackgroundColor, color: 'var(--v-navHeaderText-base)' }}>
                    {this.MenuTitle}
                </QCardSection>
            );

        const renderNodeHeader = ({ node }) => {
            let content;
            const iconName = resolveMenuIcon(node.icon);
            if (iconName)
                content = <div class="row items-center no-wrap"><QIcon name={iconName} size="sm" class="q-mr-sm" /><TranslationContainer class="text-wrap" context={this} value={node.name}></TranslationContainer></div>;
            else
                content = <div class="row items-center no-wrap"><TranslationContainer class="text-wrap" context={this} value={node.name}></TranslationContainer></div>;

            if (node.badgecontent) {
                // Vue2: v-badge value={showbadge}
                content = (
                    <span class="relative-position" style={{ display: 'inline-block' }}>
                        {content}
                        {node.showbadge ? (
                            <QBadge floating rounded label={node.badgecontent} color="negative" style={{ top: '2px', right: '-30px', transform: 'none' }} />
                        ) : null}
                    </span>
                );
                if (node.tooltip)
                    content = utils.tt(node.tooltip, content);
            }
            else if (node.item_data?.MenuItemData?.badgecontent) {
                const badgeinfo = node.item_data.MenuItemData.badgecontent;
                // count > 0: `&& count` yields 0 and Vue renders the digit (CCDEV-17971)
                content = (
                    <span class="relative-position" style={{ display: 'inline-block' }}>
                        {content}
                        {(badgeinfo.showbadge && badgeinfo.count > 0) ? (
                            <QBadge floating rounded label={badgeinfo.count < 100 ? String(badgeinfo.count) : '99+'} color="negative" style={{ top: '2px', right: '-30px', transform: 'none' }} />
                        ) : null}
                    </span>
                );
                if (badgeinfo.tooltip && Array.isArray(badgeinfo.tooltip) && badgeinfo.tooltip.length > 0)
                    content = utils.generateTooltip(h, content, badgeinfo.tooltip.map(t => <span>{this.Translate(t)}<br /></span>), 'top');
            }

            const isParent = this.isParentNode(node);
            const isSelected = !isParent && this.selected_item != null && this.selected_item == node.id;
            // Leaf: refresh while selected. Parent (debug): info hit-zone on right edge only.
            let edgeButton = null;
            if (isSelected) {
                edgeButton = utils.tt(this.labelForceRefresh,
                    <QBtn flat dense round size="sm" icon="mdi-refresh"
                        onClick={(e) => { e.stopPropagation(); this.menuItemRefresh(e, node.item_data); }}
                        onContextmenu={(e) => { e.stopPropagation(); this.showContextMenu(e, node.item_data); }}
                    />,
                    'top'
                );
            }
            const showParentInfoEdge = isParent && this.isdebug;
            const showEdgeChrome = !!edgeButton || showParentInfoEdge;
            return (
                <div
                    class={{
                        'c-DynamicMenuList-node-header': true,
                        'c-DynamicMenuList-node-header--selected': isSelected,
                        'c-DynamicMenuList-node-header--parent': isParent,
                    }}
                    role="button"
                    tabindex={0}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        width: '100%',
                        minWidth: 0,
                        padding: '6px 8px',
                        paddingRight: showEdgeChrome ? '36px' : '8px',
                        boxSizing: 'border-box',
                        cursor: 'pointer',
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                        this.handleNodeActivate(node);
                    }}
                    onKeydown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            e.stopPropagation();
                            this.handleNodeActivate(node);
                        }
                    }}
                    onContextmenu={(e) => {
                        if (!this.isdebug || !node.item_data)
                            return;
                        e.preventDefault();
                        e.stopPropagation();
                        this.showContextMenu(e, node.item_data);
                    }}
                >
                    <span style={{ flex: '1 1 0', minWidth: 0, overflow: 'hidden' }}>{content}</span>
                    {edgeButton && (
                        <span style={{ position: 'absolute', right: '4px', top: '50%', transform: 'translateY(-50%)' }}>
                            {edgeButton}
                        </span>
                    )}
                    {showParentInfoEdge && (
                        <span
                            class="c-DynamicMenuList-node-edge"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.showContextMenu(e, node.item_data);
                            }}
                            onContextmenu={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                this.showContextMenu(e, node.item_data);
                            }}
                        >
                            {utils.tt(this.labelMenuInfo,
                                <QBtn flat dense round size="sm" icon="mdi-information-outline"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.showContextMenu(e, node.item_data);
                                    }}
                                    onContextmenu={(e) => {
                                        e.stopPropagation();
                                        this.showContextMenu(e, node.item_data);
                                    }}
                                />,
                                'top'
                            )}
                        </span>
                    )}
                </div>
            );
        };

        const tv = (
            <QTree
                nodes={this.menuItemsFiltered || []}
                node-key="id"
                label-key="name"
                noConnectors
                class="c-DynamicMenuList-tree"
                expanded={this.expanded_keys}
                onUpdate:expanded={(keys) => { this.expanded_keys = keys; }}
                selected={this.selected_item}
                onUpdate:selected={(key) => {
                    if (key == null)
                        return;
                    const item = this.findItem(this.model, key);
                    if (this.isParentNode(item))
                        return;
                    this.onInput([key]);
                }}
                v-slots={{ 'default-header': renderNodeHeader }}
            />
        );


        let contextMenu;
        if (this.isdebug && this.contextMenuItem && this.showMenu) {
            const menuContent = (
                <QList>
                    <QItem>
                        <QItemSection>
                            <QItemLabel>{this.contextMenuItem.$ModuleMetaData?.ModuleName}</QItemLabel>
                            <QItemLabel caption>{this.getMenuNameAndPath(this.contextMenuItem)}</QItemLabel>
                        </QItemSection>
                    </QItem>
                    <QSeparator />
                    <QItem clickable onClick={(e) => { this.menuItemRefresh(e, this.contextMenuItem); this.showMenu = false; }}>
                        <QItemSection avatar><QIcon name="mdi-refresh" /></QItemSection>
                        <QItemSection>
                            <QItemLabel><TranslationContainer context={this} value="Reload" /></QItemLabel>
                            <QItemLabel caption><TranslationContainer context={this} value="Flushes cache and reloads" /></QItemLabel>
                        </QItemSection>
                    </QItem>
                    {this.contextMenuItem.CustomerID == this.root.CustomerID && (
                        <QItem clickable onClick={(e) => { this.openForLocalEdit(e, this.contextMenuItem); this.showMenu = false; }}>
                            <QItemSection avatar><QIcon name="mdi-pencil" /></QItemSection>
                            <QItemSection>
                                <QItemLabel><TranslationContainer context={this} value="Edit Menu Item" /></QItemLabel>
                                <QItemLabel caption><TranslationContainer context={this} value="Local Tab" /></QItemLabel>
                            </QItemSection>
                        </QItem>
                    )}
                    <QItem clickable onClick={(e) => { this.openForExternalEdit(e, this.contextMenuItem, this.contextMenuItem.CustomerID, true); this.showMenu = false; }}>
                        <QItemSection avatar><QIcon name="mdi-pencil-box-multiple" /></QItemSection>
                        <QItemSection>
                            <QItemLabel><TranslationContainer context={this} value="Edit Menu Item" /></QItemLabel>
                            <QItemLabel caption><TranslationContainer context={this} value="New Window" /></QItemLabel>
                        </QItemSection>
                    </QItem>
                    <QItem clickable onClick={(e) => { this.openForExternalEdit(e, this.contextMenuItem, this.contextMenuItem.CustomerID, false); this.showMenu = false; }}>
                        <QItemSection avatar><QIcon name="mdi-pencil-box-multiple-outline" /></QItemSection>
                        <QItemSection>
                            <QItemLabel><TranslationContainer context={this} value="Edit Menu Item" /></QItemLabel>
                            <QItemLabel caption><TranslationContainer context={this} value="New Browser Tab" /></QItemLabel>
                        </QItemSection>
                    </QItem>
                </QList>
            );
            contextMenu = (
                <div style={{ position: 'fixed', left: this.x + 'px', top: this.y + 'px', width: 0, height: 0, zIndex: 9999 }}>
                    <QMenu modelValue={this.showMenu} onUpdate:modelValue={(v) => this.showMenu = v} anchor="bottom left" self="top left">
                        {menuContent}
                    </QMenu>
                </div>
            );
        }

        return (
            <div
                class={{ 'c-DynamicMenuList': true, [`c-name-${this.name || 'unnamed'}`]: true }}
                style={style}>
                <QCard class="q-mx-auto" flat style="border-radius: unset !important; background: #fff;">
                    {title}
                    <QCardSection class="q-pa-none">
                        {tv}
                    </QCardSection>
                </QCard>
                {contextMenu}
            </div>
        );
    }
});